export interface ProfilePhoto {
  id: number;
  endpointUrl: string;
  sortOrder: number;
  createdTime: string;
}

export interface Interest {
  id: number;
  name: string;
}

export interface Region {
  level1Id: number;
  level1Name: string;
  level2Id: number;
  level2Name: string;
}

export enum PreferredAge {
  YOUNGER = 'YOUNGER',
  OLDER = 'OLDER', 
  ANY = 'ANY'
}

export enum ReviewStatus {
  DRAFT = 'DRAFT',
  SUBMITTED = 'SUBMITTED',
  APPROVED = 'APPROVED',
  UPDATED = 'UPDATED',
  REJECTED = 'REJECTED'
}

export interface PendingReview {
  hasPending: boolean;
  fieldTypes: string[]; // ['PHOTOS', 'JOB', 'ONE_LINER', 'SELF_INTRO'] — 서버가 복수로 반환
  requestedAt: string;
  pendingPhotos?: string[]; // 심사 대기 중인 사진 URL 목록 (fieldTypes에 'PHOTOS' 포함 시)
}

export interface UserProfile {
  id: number;
  userId: number;
  birthDate?: string;
  gender?: string;
  jobTitle?: string;
  residenceRegion?: Region;
  oneLiner?: string;
  selfIntro?: string;
  preferredAge: PreferredAge;
  profilePhotos: ProfilePhoto[];
  interests: Interest[];
  preferredRegions: Region[];
  createdTime?: string;
  updatedTime?: string;
  // 심사 관련
  reviewStatus?: ReviewStatus;
  submittedTime?: string;
  reviewedTime?: string | null;
  rejectReason?: string | null;
  // 재심사 관련 (서버 확장 필드)
  userStatus?: string | null;  // 서버 유저 상태 (PENDING, APPROVED, REJECTED 등)
  rejectReasonCodes?: string | null;  // 콤마 구분 코드, e.g. "PHOTO_BLUR,INFO_INCOMPLETE"
  resubmissionCount?: number;
  remainingChances?: number;
  canResubmit?: boolean;
  // 정회원 프로필 수정 관련
  pendingReview?: PendingReview;             // 심사 대기 중인 수정 요청
  residenceChangeCountThisYear?: number;     // 올해 거주지 변경 횟수 (최대 2회)
}